import { render, staticRenderFns } from "./useDirection.vue?vue&type=template&id=6bceca97&scoped=true&"
import script from "./useDirection.vue?vue&type=script&lang=ts&"
export * from "./useDirection.vue?vue&type=script&lang=ts&"
import style0 from "./useDirection.vue?vue&type=style&index=0&id=6bceca97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bceca97",
  null
  
)

export default component.exports